var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgColumn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-column_svg__clip0_816_14573)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.761 4.637c0-1.162.943-2.105 2.106-2.105h15.311c1.163 0 2.106.943 2.106 2.105v12.25a2.105 2.105 0 01-2.105 2.105H2.867A2.105 2.105 0 01.76 16.887V4.637zm2.106-.957a.957.957 0 00-.957.957v12.25c0 .528.428.957.957.957h15.311a.957.957 0 00.957-.957V4.637a.957.957 0 00-.957-.957H2.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.761 7.125h19.523V14.4H.76V7.125zM1.91 8.274v4.976h17.226V8.274H1.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46 2.34c0-.422.342-.765.765-.765h4.594c.422 0 .765.343.765.765v16.844a.766.766 0 01-.765.765H8.225a.766.766 0 01-.766-.765V2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.394 14.399H7.269V13.25h6.125V14.4zm0-7.274H7.269v1.149h6.125V7.125z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-column_svg__clip0_816_14573"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.761 .761)",
    d: "M0 0h19.523v19.523H0z"
  })))));
}
export default SvgSvgColumn;